module.exports = __webpack_public_path__ + "static/atrocity_total_cases-9935b78d413d43bf489d5ff1512aee85.png";